import AccountService from '@/services/AccountService.js'

export const namespaced = true //all mutations, actions, getters will be namespaced under "account"//

export const actions = {
  changePassword({ dispatch }, credentials) {
    return new Promise((resolve, reject) => {
      AccountService.changePassword(credentials).then((response) => {
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem changing the password: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  },
  fetchUserShippingDetails({ dispatch }) {
    return new Promise((resolve, reject) => {
      AccountService.fetchUserShippingDetails().then((response) => {
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching shipping details: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  },
  saveUserShippingDetails({ dispatch }, shippingData) {
    return new Promise((resolve, reject) => {
      AccountService.saveUserShippingDetails(shippingData).then((response) => {
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem adding shipping details: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  },
  deleteTeamMember({ dispatch }, id) {
    return new Promise((resolve, reject) => {
      AccountService.deleteTeamMember(id).then((response) => {
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem deleting team member: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  }
}
